import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Verify = () => {
  const [code, setCode] = useState('');
  const [msg, setMsg] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  const handleVerify = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('/api/verify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code })
      });
      const data = await res.json();
      if (res.ok) {
        setMsg("Zweryfikowano pomyślnie! Logowanie...");
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setMsg(data.error);
      }
    } catch (err) { setMsg("Błąd połączenia."); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0f172a] px-6">
      <div className="bg-white/5 p-10 rounded-3xl border border-white/10 w-full max-w-md text-center backdrop-blur-xl">
        <h2 className="text-2xl font-bold text-white mb-4">Weryfikacja</h2>
        <p className="text-gray-400 mb-6">Wpisz kod wysłany na:<br/><span className="text-cyan-400">{email}</span></p>
        {msg && <p className="mb-4 text-cyan-400 bg-cyan-500/10 py-2 rounded-lg">{msg}</p>}
        <form onSubmit={handleVerify} className="space-y-4">
          <input type="text" placeholder="000000" className="w-full p-4 bg-black/20 border border-white/10 rounded-xl text-white text-center text-3xl tracking-[10px] outline-none focus:border-cyan-500" onChange={e => setCode(e.target.value)} maxLength="6" required />
          <button className="w-full bg-cyan-500 py-4 rounded-xl font-bold text-white hover:bg-cyan-400 transition shadow-lg shadow-cyan-500/20">Potwierdź kod</button>
        </form>
      </div>
    </div>
  );
};
export default Verify;